export enum RegelSubItemType {
  Analyse,
  Keim,
  Keimgruppe
}
